/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type ApprovableStatus = "APPROVED" | "CANCELLED" | "PENDING" | "%future added value";
export type CreditType = "DSCR" | "OTH" | "PROMO" | "RFR" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type BrokerageCreditUpdateForm_brokerageCredit$ref: FragmentReference;
declare export opaque type BrokerageCreditUpdateForm_brokerageCredit$fragmentType: BrokerageCreditUpdateForm_brokerageCredit$ref;
export type BrokerageCreditUpdateForm_brokerageCredit = {|
  +id: string,
  +account: {|
    +id: string,
    +name: ?string,
  |},
  +description: ?string,
  +expiryDate: ?any,
  +initialAmount: number,
  +remainingAmount: number,
  +note: ?string,
  +creditType: CreditType,
  +consumed: boolean,
  +provisionedBy: ?{|
    +id: string,
    +fullName: ?string,
  |},
  +status: ApprovableStatus,
  +approvals: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +approvedBy: {|
          +id: string,
          +username: string,
        |},
        +approvedAt: any,
      |}
    |}>
  |},
  +hasCompleteApprovals: ?boolean,
  +$refType: BrokerageCreditUpdateForm_brokerageCredit$ref,
|};
export type BrokerageCreditUpdateForm_brokerageCredit$data = BrokerageCreditUpdateForm_brokerageCredit;
export type BrokerageCreditUpdateForm_brokerageCredit$key = {
  +$data?: BrokerageCreditUpdateForm_brokerageCredit$data,
  +$fragmentRefs: BrokerageCreditUpdateForm_brokerageCredit$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "BrokerageCreditUpdateForm_brokerageCredit",
  "type": "BrokerageCreditNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "account",
      "storageKey": null,
      "args": null,
      "concreteType": "AccountNode",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "expiryDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "initialAmount",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "remainingAmount",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "note",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "creditType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "consumed",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "provisionedBy",
      "storageKey": null,
      "args": null,
      "concreteType": "UserNode",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "fullName",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "approvals",
      "storageKey": null,
      "args": null,
      "concreteType": "ApprovalNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ApprovalNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ApprovalNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "approvedBy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserNode",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "username",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "approvedAt",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasCompleteApprovals",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e66d9035da8ec30ce4ecda52f60c5efb';
module.exports = node;
